import { useState, useCallback } from "react";

// Components
import { Header, Body, Button } from "../../../../UI";
import { Heading2 } from "../../../../typography";

// Containers
import WorkingDays from "../../../../../containers/forms/generalBranchSettingsForms/Schedule/WorkingDays/WorkingDays";
import SpecialDays from "../../../../../containers/forms/generalBranchSettingsForms/Schedule/SpecialDays/SpecialDays";

// Constants

// Builders
import * as buttonDesignType from "../../../../../builders/buttonDesign.types";

// Styles
import { ManageScheduleStyles } from "./manageSchedule.styles";

const WORKING_DAYS = "WORKING_DAYS";
const SPECIAL_DAYS = "SPECIAL_DAYS";

const ManageSchedule = ({ branchId }) => {
  const [activeTab, setActiveTab] = useState(WORKING_DAYS);
  const [isWorkingDaysDirty, setIsWorkingDaysDirty] = useState(false);
  const [saveWorkingDays, setSaveWorkingDays] = useState(null);

  const handleDirtyChange = useCallback(dirty => {
    setIsWorkingDaysDirty(dirty);
  }, []);

  const handleSaveRef = useCallback(submitFn => {
    setSaveWorkingDays(() => submitFn);
  }, []);

  const isSpecialDays = activeTab === SPECIAL_DAYS;

  return (
    <ManageScheduleStyles>
      <Header>
        <div className="cardHeaderRow">
          <Heading2>MANAGE SCHEDULE</Heading2>
          {activeTab === WORKING_DAYS && isWorkingDaysDirty && (
            <Button
              className="sectionSaveBtn"
              onClick={() => saveWorkingDays?.()}
              buttonDesignType={buttonDesignType.PRIMARY}
            >
              Save Changes
            </Button>
          )}
        </div>
      </Header>
      <Header className="tabBarSection">
        <div className="tabBar">
          <div className={`tabSlider ${isSpecialDays ? "right" : ""}`} />
          <div
            onClick={() => setActiveTab(WORKING_DAYS)}
            className={`tabPill ${!isSpecialDays ? "active" : ""}`}
          >
            Working Days
          </div>
          <div
            onClick={() => setActiveTab(SPECIAL_DAYS)}
            className={`tabPill ${isSpecialDays ? "active" : ""}`}
          >
            Special Days
          </div>
        </div>
      </Header>
      <Body className="body">
        {activeTab === WORKING_DAYS && (
          <WorkingDays
            branchId={branchId}
            onDirtyChange={handleDirtyChange}
            onSaveRef={handleSaveRef}
          />
        )}
        {activeTab === SPECIAL_DAYS && (
          <SpecialDays branchId={branchId} />
        )}
      </Body>
    </ManageScheduleStyles>
  );
};

export default ManageSchedule;
